/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $StaffSurveyQuestionForDetails = {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        question: {
    type: 'string',
    isRequired: true,
},
        questionType: {
    type: 'Enum',
    isRequired: true,
},
        isRequired: {
    type: 'boolean',
    isRequired: true,
},
        options: {
    type: 'array',
    contains: {
        type: 'StaffSurveyQuestionOption',
    },
    isRequired: true,
},
        createdAt: {
    type: 'string',
    isRequired: true,
    format: 'date-time',
},
        archivedAt: {
    type: 'string',
    isNullable: true,
    format: 'date-time',
},
    },
};